import {IntegrationType} from "../types"

export interface TypeInfo {
  name: string
  description: string
}

export const INTEGRATION_TYPE_INFO: Record<IntegrationType, TypeInfo> = {
  Authentication: {
    name: "Authentication",
    description: "Enable single sign-on (SSO) for the Quartz web platform",
  },
  "HR & Directory": {
    name: "HR & Directory",
    description: "Manage user groups and import user data",
  },
  Messaging: {
    name: "Messaging",
    description: "Archive communications from messaging platforms",
  },
  Storage: {
    name: "Storage",
    description: "Archive files and documents from storage platforms",
  },
  "Call Center": {
    name: "Call Center",
    description: "Archive call recordings and metadata",
  },
}
